import axiosInstance from "./axios";

export class AlumnoService {
    /**
     * Obtiene alumnos por ciclo y salón
     * @param {Object} dto { ciclo, salon, nombres }
     */
    getAlumnosByCiclo(dto) {
        return axiosInstance
            .get("/matricula/byciclo", { params: dto })
            .then((res) => res.data)
    }

    /**
     * Obtiene alumno por DNI
     * @param {Object} dni { documentoidentidad }
     */
    getAlumnoDNI(dni) {
        return axiosInstance
            .get("/alumno", { params: dni })
            .then((res) => res.data)
    }

    /**
     * Obtiene alumno por ID
     * @param {string} id 
     */
    getAlumnoId(id) {
        return axiosInstance
            .get(`/alumno/${id}`)
            .then((res) => res.data)
    }

    /**
     * Registra un nuevo alumno
     * @param {Object} dto 
     */
    addAlumno(dto) {
        return axiosInstance
            .post("/alumno", dto)
            .then((res) => res.data)
    }

    /**
     * Actualiza datos de un alumno
     * @param {Object} dto 
     */
    updateAlumno(dto) {
        return axiosInstance
            .put(`/alumno/${dto._id}`, dto)
            .then((res) => res.data)
    }

    /**
     * Elimina un alumno
     * @param {string} id 
     */
    deleteAlumno(id) {
        return axiosInstance
            .delete(`/alumno/${id}`)
            .then((res) => res.data)
    }

    /**
     * Gestión de Matrículas
     */
    addMatricula(dto) {
        return axiosInstance
            .post("/matricula", dto)
            .then((res) => res.data)
    }

    updateMatricula(dto) {
        return axiosInstance
            .put(`/matricula/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteMatricula(id) {
        return axiosInstance
            .delete(`/matricula/${id}`)
            .then((res) => res.data)
    }

    /**
     * Pagos e Incidencias
     */
    getPagoMatriculaPorIdMatricula(dto) {
        return axiosInstance
            .get("/pagomatricula", { params: dto })
            .then((res) => res.data)
    }

    getIncidencias(dto) {
        return axiosInstance
            .get("/incidenciasalumnos", { params: dto })
            .then((res) => res.data)
    }

    addIncidencia(dto) {
        return axiosInstance
            .post("/incidenciasalumnos", dto)
            .then((res) => res.data)
    }

    updateIncidencia(dto) {
        return axiosInstance
            .put(`/incidenciasalumnos/${dto._id}`, dto)
            .then((res) => res.data)
    }

    addPagoMatricula(dto) {
        return axiosInstance
            .post("/pagomatricula", dto)
            .then((res) => res.data)
    }

    updatePagoMatricula(dto) {
        return axiosInstance
            .put(`/pagomatricula/${dto._id}`, dto)
            .then((res) => res.data)
    }

    updateCarnetImpreso(id) {
        return axiosInstance
            .put(`/matricula/carnet/${id}`)
            .then((res) => res.data)
    }

    /**
     * Obtiene todas las matrículas de un alumno por su ID
     * @param {string} alumnoId
     */
    getMatriculasByAlumno(alumnoId) {
        return axiosInstance
            .get("/matricula", { params: { alumno: alumnoId } })
            .then((res) => res.data)
    }

    /**
     * Restablece la contraseña de un alumno
     * @param {string} alumnoId
     * @param {Object} dto { nombreusuario, contrasena, rol }
     */
    resetPassword(alumnoId, dto) {
        return axiosInstance
            .put(`/usuario/resetpassword/${alumnoId}`, dto)
            .then((res) => res.data)
    }

    getModulos() {
        return axiosInstance
            .get("/modulo")
            .then((res) => res.data)
    }
}
